export enum CashProviderEnum {
    aqsi = 'AQSI',
}
